import CollapseContent from "../Utils/CollapseContent";
import RichText from "../Utils/RichText";

const OptionDescription = ({ description }) => (
  <CollapseContent className="option-description">
    <RichText
      content={description}
      className="padding-top-xs option-description__inner"
    />
  </CollapseContent>
);

export default OptionDescription;
